import React from 'react'
import PropTypes from 'prop-types'

import { Alert } from 'components/patterns'
import { Col } from 'components/patterns/Layout'
import { Header } from 'components/patterns/Typography'

import strings from 'utils/strings'
import { STAGES } from './BatchImport.hook'
import {
  StepperRow,
  StepperLabelCol,
  StyledSteps,
  HeaderStyled,
} from './BatchImport.styles'

const BatchImportHeader = ({
  handleCancel,
  stage,
  currentPartNumber,
  steps,
}) => (
  <HeaderStyled>
    <Alert
      type="info"
      persistent
      actionTrigger={{
        onClick: handleCancel,
        text: strings.exit_import_logic,
      }}
      message={`${strings.importing_feature_contents_to} ${currentPartNumber}`}
    />
    <StepperRow alignItems="start">
      <StepperLabelCol justifyContent="center" alignItems="start" span={3}>
        <Header type="h1">{strings.import_logic}</Header>
      </StepperLabelCol>
      <Col offset={2} span={14}>
        <StyledSteps
          steps={steps}
          currentStep={STAGES[stage]}
          labelPlacement="vertical"
        />
      </Col>
    </StepperRow>
  </HeaderStyled>
)

BatchImportHeader.propTypes = {
  handleCancel: PropTypes.func,
  stage: PropTypes.string,
  currentPartNumber: PropTypes.string,
  steps: PropTypes.array,
}

export default BatchImportHeader
